import { Alert, Button, Dialog, DialogActions, DialogTitle } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom-v5-compat";

interface Props {
  gtin: string;
}

export const InvalidGtinDialog: React.FC<Props> = ({ gtin }) => {
  const navigate = useNavigate();
  return (
    <Dialog open={true}>
      <Alert severity="warning">
        <DialogTitle>{`Gtin (${gtin}) jest niepoprawny`}</DialogTitle>
        <DialogActions>
          <Button onClick={() => navigate(-1)}>Powrót</Button>
          <Button onClick={() => navigate("/")}>Strona Główna</Button>
        </DialogActions>
      </Alert>
    </Dialog>
  );
};
